/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatMap, map } from 'rxjs/operators';
import { BackendService } from '../../../../../utils/src';
import {
  BrowseClick,
  BrowseClickSuccess,
  GetReturnCodeAfterExport,
  GetReturnCodeAfterExportSuccess,
  GetVisibleInvisibleSystems,
  GetVisibleInvisibleSystemsSuccess,
  onSystemManagerItemClickAction,
  onSystemManagerItemClickActionSuccess,
} from './system-manager-actions';
import { of } from 'rxjs';

@Injectable()
export class SystemManagerEffects {
  constructor(private readonly actions$: Actions, private backendService: BackendService) {}

  getVisibleInvisibleSystems$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetVisibleInvisibleSystems),
      concatMap(() =>
        this.backendService
          .getVisibleInvisibleSystems()
          .pipe(map((data) => GetVisibleInvisibleSystemsSuccess({ visibleInvisibleSystems: data })))
      )
    );
  });

  onExportButtonClicked$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(GetReturnCodeAfterExport),
      concatMap((action) => {
        return this.backendService
          .onExportButtonClicked(action.selectedSystems)
          .pipe(map((data) => GetReturnCodeAfterExportSuccess({ returnCodeExport: data })));
      })
    );
  });

  browseClick$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(BrowseClick),
      concatMap(() =>
        this.backendService.browseClick().pipe(map((data) => data && BrowseClickSuccess({ response: data })))
      )
    );
  });

  onSystemManagerItemClickAction$ = createEffect(() => this.actions$.pipe(
    ofType(onSystemManagerItemClickAction),
    concatMap((action) => {
      this.backendService.onSystemManagerItemClick(action.route, action.width, action.height);
      return of(onSystemManagerItemClickActionSuccess());
    })
  ));
}
